import { LinkItem } from '@occc-app/design-system';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

import { routeCreator } from '../stored-value.utils';

export const STORED_VALUE_UPDATE_PAGE_TITLE = 'Edit Stored Value Program';

export const getStoredValueUpdateBreadcrumbLinks = (offerName: string): LinkItem[] => [
  {
    to: programManagementRouteCreator.base(),
    label: 'Program Management',
  },
  {
    to: routeCreator.list,
    label: 'Stored Value Programs',
  },
  {
    label: offerName || STORED_VALUE_UPDATE_PAGE_TITLE,
  },
];
